import { render, staticRenderFns } from "./cancel-assignment-modal.vue?vue&type=template&id=338aa566"
import script from "./cancel-assignment-modal.vue?vue&type=script&lang=js"
export * from "./cancel-assignment-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports